// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Skeleton, Text } from '@mantine/core';
import { FC, useEffect, useState } from 'react';
import { i18n } from '@lingui/core';
import { ChangeEventStatusConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';
import { CustomEventState } from '../../../../Types/EventT';
import { EventS } from '../../../../Service/EventS';
import { WorkflowS } from '../../../../Service/WorkflowS';
import { getReportExecutionState } from './reportExecutionState';

const ChangeEventStatusReport: FC<ProcedureReportProps> = ({ report, config }) => {
  const { bookingState, customStateId } = config as ChangeEventStatusConfigDTO;
  const executionState = getReportExecutionState(report?.executionStatus);
  const [customState, setCustomState] = useState<CustomEventState | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (customStateId) {
      setLoading(true);
      EventS.fetchCustomState(customStateId)
        .then(setCustomState)
        .finally(() => setLoading(false));
    }
  }, [customStateId]);

  let intro = 'Eventstatus wird auf';
  if (executionState === 'COMPLETED') {
    intro = 'Eventstatus wurde auf';
  }
  if (executionState === 'SKIPPED') {
    intro = 'Änderung des Eventstatus auf';
  }
  if (executionState === 'NOT_EXECUTED') {
    intro = 'Eventstatus wurde nicht auf';
  }

  return (
    <Text>
      {intro}{' '}
      <Text span weight="bolder">
        {loading ? (
          <Skeleton mr={8} ml={8} mb={-3} width={100} height={16} sx={{ display: 'inline-block' }} />
        ) : (
          customState ? customState.label : i18n._(`bookingState.${bookingState}`)
        )}
      </Text>{' '}
      {executionState === 'SKIPPED' ? 'wurde übersprungen.' : 'gesetzt.'}
      {WorkflowS.getWorkflowErrorDescription(report)}
    </Text>
  );
};

export default ChangeEventStatusReport;
